// =============================================================================
// hooks/crm/useLeadStats.ts — Totais da lista de leads (GET /api/leads/stats).
//
// Mesmos filtros e mesmo escopo da lista (F58-S07): os cartões do CRM contam
// o conjunto que a tabela mostra, não só a página de 20 (CRM-05).
// Resposta validada com o schema do contrato — drift front×API falha alto.
// =============================================================================

import type { LeadStatsResponse } from '@elemento/shared-schemas';
import { LeadStatsResponseSchema } from '@elemento/shared-schemas';
import { useQuery } from '@tanstack/react-query';

import { api } from '../../lib/api';

import { buildLeadFiltersQuery, toStatsFilters } from './leadFilters';
import type { LeadFilters } from './types';

// Prefixo ['leads'] de propósito: invalidar 'leads' atualiza lista e totais.
export const LEAD_STATS_QUERY_KEY = (filters: LeadFilters) =>
  ['leads', 'stats', toStatsFilters(filters)] as const;

export async function fetchLeadStats(filters: LeadFilters): Promise<LeadStatsResponse> {
  const qs = buildLeadFiltersQuery(filters, { includePaging: false });
  const raw = await api.get<unknown>(`/api/leads/stats${qs ? `?${qs}` : ''}`);
  return LeadStatsResponseSchema.parse(raw);
}

export function useLeadStats(filters: LeadFilters): {
  data: LeadStatsResponse | undefined;
  isLoading: boolean;
  isError: boolean;
} {
  const { data, isLoading, isError } = useQuery({
    queryKey: LEAD_STATS_QUERY_KEY(filters),
    queryFn: () => fetchLeadStats(filters),
    staleTime: 30_000,
    placeholderData: (prev) => prev,
  });
  return { data, isLoading, isError };
}
